
import React from 'react';


export default function TermPage() {
  return (
    <div className="policy-container">
  
      <h1>Terms and Conditions for Shoreline Defender App</h1>
      <p className="effective-date">Effective Date: May 20, 2025</p>
      <p>Welcome to the Shoreline Defender mobile app (the "App"). By using this App, you agree to the following legally binding Terms and Conditions.</p>

      <h2>1. Purpose and Scope</h2>
      <p>This App provides a location-based display of public beach access boundaries derived from third-party data sources including NOAA, geospatial elevation models, and publicly available map layers. Users may also log coastal access incidents.</p>

      <h2>2. User Acknowledgment and Risk Disclaimer</h2>
      <ul>
        <li>You understand and agree that the boundaries shown in this app do not constitute legal advice, legal determinations, or enforceable property lines.</li>
        <li>All data is informational only and is provided "as-is" with no warranties or guarantees of accuracy, legality, or completeness.</li>
        <li>Shoreline Defender LLC shall not be liable for any direct, indirect, incidental, or consequential damages resulting from reliance on app data or use in a real-world scenario.</li>
      </ul>

      <h2>3. Use of the App</h2>
      <ul>
        <li>You agree not to misuse, reverse-engineer, or interfere with the operation of the app.</li>
        <li>You are responsible for compliance with all local, state, and federal laws while using this app.</li>
      </ul>

      <h2>4. Intellectual Property</h2>
      <p>All content, graphics, software, and data models are the intellectual property of Shoreline Defender LLC or its licensors. Unauthorized reproduction or redistribution is prohibited.</p>

      <h2>5. No Attorney-Client Relationship</h2>
      <p>Use of the App does not create an attorney-client relationship. The content is not legal advice.</p>

      <h2>6. Indemnification</h2>
      <p>By using the App, you agree to indemnify, defend, and hold harmless Shoreline Defender LLC and its officers, directors, agents, and affiliates from any claims, liabilities, damages, losses, or expenses arising from your use of the App or violation of these Terms.</p>

      <h2>7. Limitation of Liability</h2>
      <p>To the fullest extent permitted by law, Shoreline Defender LLC’s total liability to you for any claims under these Terms, including implied warranties, is limited to one U.S. dollar ($1).</p>

      <h2>8. Termination of Access</h2>
      <p>We reserve the right to suspend or terminate your access to the App at any time for violations of these Terms or for technical or legal reasons.</p>

      <h2>9. Modifications</h2>
      <p>These Terms may be updated. Continued use of the App signifies acceptance of the latest version.</p>

      <h2>10. Governing Law</h2>
      <p>These Terms shall be governed by and construed in accordance with the laws of the State of Wyoming, without regard to its conflict of law provisions. Any dispute arising under or related to this Agreement shall be resolved exclusively in the state or federal courts located in Wyoming.</p>

      <h2>11. Contact</h2>
      <p>
        For questions or legal notices:<br/>
        Shoreline Defender LLC<br/>
        <a href="mailto:admin@shorelinedefenderapp.com">admin@shorelinedefenderapp.com</a>
      </p>
    </div>
  );
}

